module.exports = __webpack_public_path__ + "static/media/belarus-large.560a75c3.jpg";